import { render, staticRenderFns } from "./cModalMedicFrequencyview.vue?vue&type=template&id=e92ea1e0&scoped=true"
import script from "./cModalMedicFrequencyview.vue?vue&type=script&lang=js"
export * from "./cModalMedicFrequencyview.vue?vue&type=script&lang=js"
import style0 from "./cModalMedicFrequencyview.vue?vue&type=style&index=0&id=e92ea1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92ea1e0",
  null
  
)

export default component.exports